<template>
  <v-card>
    <v-card-title>
      <div>
        <small><span
        v-if="transaction.currency">{{transaction.amount | price(transaction.currency)}}</span><span
        v-else>{{transaction.amount}}</span> | {{transaction.org_notes}}</small>
      </div>
      <v-spacer></v-spacer>
      <div>
        <loading-state text="" :state="state"></loading-state>
        <v-btn color="blue darken-1" text v-show="!state.isLoading()" @click="cancel">Cancel</v-btn>
        <v-btn :disabled="(!valid) || state.isLoading()" color="success" class="mr-4" @click="validateAndSave">Save</v-btn>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs6 sm4>
              <v-autocomplete
                v-model="transaction.category.key"
                :loading="categoryLoading"
                :items="categories"
                ref="catinput"
                label="Category"
                autofocus
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 sm6>
              <v-autocomplete
                v-model="transaction.tags"
                :loading="tagLoading"
                :items="tags"
                multiple
                chips
                small-chips
                deletable-chips
                dense
                label="Tags"
                ref="taginput"
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 sm2>
              <v-autocomplete
                v-model="transaction.review_status"
                :items="reviewStatus"
                dense
                label="Review"
                ref="reviewinput"
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 sm6>
              <v-text-field
                v-model="transaction.narration"
                label="Narration" 
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
                ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6>
              <v-text-field
                v-model="transaction.notes"
                label="Notes" 
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
                ></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import Utils from "@/utils"
import { DataState } from "@/state"
import { Account } from "@/models/account"
import { Category } from "@/models/category"
import { Tag } from "@/models/tag"
import { Transaction, ReviewStatus } from "@/models/transaction"
export default {
  props: {
    transaction: {
      default: ()=>{return Transaction.newEmpty()},
      type: Object
    }
  },
  data: () => ({
    dateFormat: 'YYYY-M-D',
    timeFormat: 'HH:mm',
    dateFormatted: '',
    state: DataState.newNotInit(),
    accountLoading: false,
    accounts: [],
    categoryLoading: false,
    categories: [],
    tagLoading: false,
    tags: [],
    reviewStatus: ReviewStatus,
    datemenu: false,
    valid: true,
    lazy: true
  }),
  watch: {
    'transaction.key' (val) {
      this.onTransactionChange()
    }
  },
  mounted () {
    this.onLoaded()
  },
  methods: {
    onLoaded () {
      if(this.transaction.date) {
        this.dateFormatted = this.formatDate(this.transaction.date)
      }

      this.accountLoading = true
      Account.list().then((response) => {
        this.accounts = response.map((r) => {
          return { text: r.name, value: r.key }
        })
        this.accountLoading = false
        this.categoryLoading = true
        return Category.list()
      }).then((response) => {
        this.categories = response.map((r) => {
          return { text: r.name, value: r.key }
        })
        this.categoryLoading = false
        this.tagLoading = true
        return Tag.list()
      }).then((response) => {
        this.tags = response.map((r) => {
          return { text: r.name, value: r.name }
        })
        this.tagLoading = false
      }).catch((error) => {
        console.log('Err', error)
      })
    },

    cancel () {
      this.$emit('input', false)
      this.$emit('canceled', this.transaction, false)
    },

    cancelAndNext () {
      this.$emit('input', false)
      this.$emit('canceled', this.transaction, true)
    },

    validateAndSave () {
      if (this.$refs.form.validate()) {
        this.saveTransaction()
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    formatDate (date) {
      return moment(date, this.dateFormat).format(this.dateFormat)
    },

    parseDate (date) {
      let newDate = date
      if (!newDate) {
        newDate = this.transaction.date
      }
      return moment(newDate, this.dateFormat).format(this.dateFormat)
    },

    saveTransaction () {
      this.valid = false
      this.state.changeToLoading()
      this.transaction.editCat().then((response) => {
        // this.transaction = Transaction.newEmpty()
        this.state.changeToLoaded()
        this.$emit('saved', response, true)
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    onTransactionChange () {
      this.$refs.form.resetValidation()
      this.$refs.catinput.focus()
    },
  },
}
</script>